import { GoogleOAuthProvider } from '@react-oauth/google';
import { init } from '@sentry/react';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { FallbackSpin } from '@/components';
import App from './App';
import { AppContextProvider } from './app/context';
import { store } from './app/store';
import Config from './configs/appConfig';
import './assets/icons/remixicon.css';
import './assets/styles/index.css';
import { ConfigProvider } from 'antd';
import antdTheme from '@/configs/antdTheme';
import { disableAntdFutureVersionWarnings } from './lib/disableAntdFutureVersionWarnings';
import { registerChunkLoadErrorHandler } from './lib/registerChunkLoadErrorHandler';

if (document.location.hostname === 'localhost') {
  disableAntdFutureVersionWarnings();
}

registerChunkLoadErrorHandler();

const root = createRoot(document.getElementById('root'));

init({
  dsn: Config.VITE_SENTRY_DSN,
  environment: Config.VITE_APP_ENVIRONMENT ?? 'local',
});

root.render(
  <Suspense fallback={<FallbackSpin />}>
    <ConfigProvider theme={antdTheme}>
      <Provider store={store}>
        <GoogleOAuthProvider clientId={Config.VITE_GOOGLE_CLIENT_ID}>
          <AppContextProvider>
            <App />
          </AppContextProvider>
        </GoogleOAuthProvider>
      </Provider>
    </ConfigProvider>
  </Suspense>,
);

// eslint-disable-next-line no-console
console.log('Frontend version:', Config.LAST_COMMIT_DATA);
